import React from 'react';

const ContactCenterList = () => {

    return (
        <>
            {/* Aquí va el listado :) */}
        </>
    )
}

export default ContactCenterList
